import styled from 'styled-components';
import { Select } from '../select';
import { SCREEN_SIZE } from '../grid/constants/sizes';
export const DateSelectContainer = styled.div `
    display: flex;
    position: relative;
    justify-content: space-between;
`;
export const InputSelect = styled(Select) `
    @media (max-device-width: ${SCREEN_SIZE.MOBILE.max}) {
        min-width: 90px;
    }
`;
export const SelectSpace = styled.div `
    width: 40px;
`;
export const DateLabel = styled.label `
    position: absolute;
    font-size: .9rem;
    top: -.2rem;
    left: 0;
    font-weight: 300;
    letter-spacing: .02rem;
    font-family: Barlow;
`;
//# sourceMappingURL=dateSelect.styled.js.map